import React from "react"
import styled from "styled-components"

import visaLogo from "../images/visa.svg"
import mcLogo from "../images/mastercard.svg"

const Logo = styled.img`
  height: 24px;
`

const CircuitLogo = (type?: string) => {
  switch (type) {
    case "visa":
      return <Logo src={visaLogo} alt="Visa logo" />
    case "mc":
      return <Logo src={mcLogo} alt="Mastercard logo" />
    default:
      return null
  }
}

export default CircuitLogo
